
import { Obj_Db_Property } from '../../datapoint/obj_db_property';
import { Db_PropertyType } from '../../datapoint/dbPropertyType';
import { Rce_DxSubUnit } from './rce_dxsubunit';
import { CommonEnums } from '../../../common.enums';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Rce_DxSubUnitsUtil } from 'src/app/shared/utils/rce_dxsubunits.util';

export class SQLOverride {
    dxFlow_Id: number;
    dxJob_Id: number;
    dxUnit_Id: number;
    dxUnitNm: number;
    obj_Cd: string;
    rce_DxSubUnits: Array<Rce_DxSubUnit>;
    imageUrl: string;
    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;
    showRunPropertiesFlag: boolean;
    overrideFlag: string;
    runtime_Change_Ind: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.dxJob_Id = CommonEnums.defaults.LONG_VAL;
        this.dxUnit_Id = CommonEnums.defaults.LONG_VAL;
        this.dxUnitNm = CommonEnums.defaults.LONG_VAL;
        this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.rce_DxSubUnits = new Array<Rce_DxSubUnit>();
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();
        this.showRunPropertiesFlag = false;
        this.overrideFlag = CommonEnums.defaults.STRING_EMPTY;
        this.runtime_Change_Ind = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(sqloverrideTmp: SQLOverride): SQLOverride {
        let sqloverride: SQLOverride = new SQLOverride();
        sqloverride.copyFrom(sqloverrideTmp as SQLOverride);
        return sqloverride;
    }

    copy(): SQLOverride {
        let sqloverrideTmp: SQLOverride = new SQLOverride();

        sqloverrideTmp.dxFlow_Id = this.dxFlow_Id;
        sqloverrideTmp.dxJob_Id = this.dxJob_Id;
        sqloverrideTmp.dxUnit_Id = this.dxUnit_Id;
        sqloverrideTmp.dxUnitNm = this.dxUnitNm;
        sqloverrideTmp.obj_Cd = this.obj_Cd;
        sqloverrideTmp.rce_DxSubUnits = Rce_DxSubUnitsUtil.getInstance().copy(this.rce_DxSubUnits);
        sqloverrideTmp.imageUrl = this.imageUrl;
        sqloverrideTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        sqloverrideTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        sqloverrideTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);
        sqloverrideTmp.showRunPropertiesFlag = this.showRunPropertiesFlag;
        sqloverrideTmp.overrideFlag = this.overrideFlag;
        sqloverrideTmp.runtime_Change_Ind = this.runtime_Change_Ind;

        return sqloverrideTmp;
    }

    copyFrom(sqloverrideTmp: SQLOverride): void {
        this.dxFlow_Id = sqloverrideTmp.dxFlow_Id;
        this.dxJob_Id = sqloverrideTmp.dxJob_Id;
        this.dxUnit_Id = sqloverrideTmp.dxUnit_Id;
        this.dxUnitNm = sqloverrideTmp.dxUnitNm;
        this.obj_Cd = sqloverrideTmp.obj_Cd;
        Rce_DxSubUnitsUtil.getInstance().copyFrom(this.rce_DxSubUnits, sqloverrideTmp.rce_DxSubUnits)
        this.imageUrl = sqloverrideTmp.imageUrl;
        this.sel_Run_PropertyType_Cd = sqloverrideTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, sqloverrideTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, sqloverrideTmp.runPropertyTypes);
        this.showRunPropertiesFlag = sqloverrideTmp.showRunPropertiesFlag;
        this.overrideFlag = sqloverrideTmp.overrideFlag;
        this.runtime_Change_Ind = sqloverrideTmp.runtime_Change_Ind
    }

    compare(sqloverrideTmp: SQLOverride): string {
        let sqloverrideString: string = toString();
        let sqloverrideTmpString: string = sqloverrideTmp.toString();

        if (sqloverrideString != sqloverrideTmpString) {
            return sqloverrideString + ', ' + sqloverrideTmpString;
        }

        return '';
    }

    tostring(): string {
        return "SQLOverride [dxFlow_Id=" + this.dxFlow_Id +
            ", dxJob_Id=" + this.dxJob_Id +
            ", dxUnit_Id=" + this.dxUnit_Id +
            ", dxUnitNm=" + this.dxUnitNm +
            ", obj_Cd=" + this.obj_Cd +
            ", rce_DxSubUnits=" + Rce_DxSubUnitsUtil.getInstance().toString(this.rce_DxSubUnits) +
            ", imageUrl=" + this.imageUrl +
            ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes) +
            ", showRunPropertiesFlag=" + this.showRunPropertiesFlag +
            ", overrideFlag=" + this.overrideFlag + 
            ", runtime_Change_Ind=" + this.runtime_Change_Ind + "]";
    }
}